
import { connect } from "react-redux";

import { post } from "../../actions/general";
import loadingComponent from "./loadable";

export default connect(null, { post })(loadingComponent);
